import { createDocument } from '../services/documents';

const resendNFE = async (transactionPk: number): Promise<any> => {
  const data = await createDocument(transactionPk, 'nfe/resend');

  return data;
};

export { resendNFE };
